import React, { useState } from 'react';

import { Reveal } from '../../../../components/Reveal';
import { faqs } from '../../../../data/faqs';
import { Section, SectionInner } from '../../styles';
import { ContactForm } from '../ContactForm';
import { Answer, Heading, Inner, Item, List, Question, Sign } from './styles';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <Section id="faq">
      <SectionInner>
        <Inner>
          <Heading>Perguntas frequentes</Heading>

          <List>
            {faqs.map((faq, index) => {
              const open = openIndex === index;

              return (
                <Reveal direction="up" delay={(index % 4) * 90} key={faq.q}>
                  <Item>
                    <Question
                      type="button"
                      onClick={() => setOpenIndex(open ? null : index)}
                    >
                      <span>{faq.q}</span>
                      <Sign>{open ? '–' : '+'}</Sign>
                    </Question>
                    <Answer open={open}>{open && <p>{faq.a}</p>}</Answer>
                  </Item>
                </Reveal>
              );
            })}
          </List>

          <ContactForm />
        </Inner>
      </SectionInner>
    </Section>
  );
};

export { FAQ };
